import {
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESSFUL,
  VERIFY_EMAIL_FAILED
} from "./actionTypes";

const initialState = {
  message: null,
  loading: false,
  user: null,
  first_name: null,
  last_name: null,
  success: false,
  error: false
};

const VerifyEmail = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_EMAIL:
      state = {
        ...state,
        loading: true,
        message: null,
      };
      break;
    case VERIFY_EMAIL_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload.data[0].email,
        first_name: action.payload.data[0].first_name,
        last_name: action.payload.data[0].last_name,
        success: true,
        message: null,

      };
      break;
    case VERIFY_EMAIL_FAILED:
      state = {
        ...state,
        user: null,
        first_name: null,
        last_name: null,
        loading: false,
        message: action.payload,
        error: true
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VerifyEmail;
